import React from 'react';
import { IconSuccess } from '@americanexpress/dls-react';

const SuccessPage = () => (
  <div className="margin-responsive">
    <h1>Submission Confirmed <IconSuccess /></h1>
    <div className="new-line" />
    <h4>
      Your request has been successfully submitted!
    </h4>
  </div>
);

export default SuccessPage;
